<template>
  <div>
    <MultipleAreaBase
      v-model="inputedValue"
      :width="width"
      :title="title"
      :tables="pageData"
    >
      <template v-slot:[pageData[0].name]="{ item }">
        <slot :name="pageData[0].name" v-bind:item="item">
          <!-- 入出金 -->
          <div class="py-6 px-10">
            <div class="pb-8">
              <span class="mr-6">
                <!-- 合計金額 -->
                {{ $t(item.items[0].name) }}：
                <span class="font-weight-bold">
                  {{ formatPrice(item.items[0].data).toLocaleString() }}
                  {{ unitName }}
                </span>
              </span>
              <span>
                <!-- 未入出金金額 -->
                {{ $t(item.items[1].name) }}：
                <span class="red--text">
                  <span class="font-weight-bold">
                    {{ formatPrice(item.items[1].data).toLocaleString() }}
                  </span>
                  {{ unitName }}
                </span>
              </span>
            </div>
            <div class="yCenter">
              <!-- 入出金日 -->
              <div class="yCenter pb-8">
                <span>{{ $t(item.items[2].name) }}</span>
                <NormalDatePicker
                  class="pl-4 pr-7"
                  width="137px"
                  v-model="item.data.date"
                />
              </div>

              <!-- 入出金金額 -->
              <div>
                <div class="yCenter">
                  <span>{{ $t(item.items[3].name) }}</span>
                  <NormalNumberInput
                    class="pl-4 pr-7 normalNumberInput"
                    v-model="item.data.notPayAmount"
                  />
                </div>
                <div class="pt-3">
                  ※{{ $t('common.common_gain-loss') }}：
                  {{ exchangeGainLoss && exchangeGainLoss > 0 ? '+' : '' }}
                  {{
                    exchangeGainLoss || exchangeGainLoss === 0
                      ? exchangeGainLoss.toLocaleString() +
                        getUserCurrencyUnit()
                      : '0' + getUserCurrencyUnit()
                  }}
                </div>
              </div>

              <!-- 入出金手段 -->
              <span class="pb-8">{{ $t(item.items[4].name) }}</span>
              <component
                :key="paymentMethod.key"
                :is="item.items[4].component"
                class="pl-4 pb-8 stepComponent"
                v-model="item.data.method"
                :isHideUnusedPaymentMethod="true"
              />

              <NormalTextButton
                class="pb-8"
                :text="$t(item.items[5].name)"
                @click="paymentMethod.dialog = true"
              />
              <MasterPaymentMethodDialog
                v-model="paymentMethod.dialog"
                @success="successPaymentMethod"
              />

              <NormalButton
                class="btnStyle ml-2 mr-4 mb-8"
                :text="item.items[6].name"
                height="32px"
                width="90px"
                @click="register()"
              />
            </div>
          </div>
        </slot>
      </template>
      <template v-slot:[pageData[1].name]="{ item }">
        <PaymentTable
          :item="item"
          :unitName="unitName"
          :paymentType="paymentType"
          @cancel="cancel"
        />
      </template>

      <template v-slot:[pageData[2].name]="{ item }">
        <slot :name="pageData[2].name" v-bind:item="item" />
      </template>
      <template v-slot:[pageData[3].name]="{ item }">
        <slot :name="pageData[3].name" v-bind:item="item" />
      </template>
    </MultipleAreaBase>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { paymentMethodUtil, currencyUtil, commonUtil } from '@/util'
import MultipleAreaBase from '../MultipleAreaBase'
import {
  NormalDatePicker,
  NormalNumberInput,
  SelectPaymentMethod,
  NormalTextButton,
  NormalButton
} from '@/components/items'

import MasterPaymentMethodDialog from '@/components/layouts/Dialogs/Master/PaymentMethod/MasterPaymentMethodDialog'
import PaymentTable from '@/components/items/Tables/PaymentTable'

export default {
  components: {
    MultipleAreaBase,
    NormalDatePicker,
    NormalNumberInput,
    SelectPaymentMethod,
    NormalTextButton,
    NormalButton,
    MasterPaymentMethodDialog,
    PaymentTable
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },

    pageData: [
      // {
      //   title: { default: '' },
      //   name: { default: '' },
      //   items: { default: [] },
      //   itemKey: { default: '' }
      // }
    ],
    currencyId: { default: '' },
    paymentType: { default: '' },
    exchangeGainLoss: { default: '' }
  },
  data: () => ({
    unitName: '',

    paymentMethod: {
      dialog: false,
      key: 0
    },
    isHideUnusedPaymentMethod: true
  }),
  created() {
    this.unitName = currencyUtil.findCurrencyNameById(this.currencyId).unitName
  },
  methods: {
    successPaymentMethod() {
      this.paymentMethod.dialog = false
      this.paymentMethod.key = this.paymentMethod.key ? 0 : 1
    },

    register() {
      this.$emit('register')
    },
    cancel(id) {
      this.$emit('cancel', id)
    },
    getPaymentMethod(id) {
      return paymentMethodUtil.getPaymentMethodName(id)
    },
    formatPrice(price) {
      return commonUtil.formatPrice(price)
    },
    getUserCurrencyUnit() {
      return currencyUtil.findCurrencyNameById(
        this.getUserInfoFromState.organization.currencyId
      ).unitName
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    ...mapGetters('User', ['getUserInfoFromState'])
  }
}
</script>
<style lang="scss" scoped>
.productTableCom {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1);
    padding-left: 30px;
  }
  ::v-deep .v-data-table td {
    padding-left: 30px;
  }
}
.normalNumberInput {
  width: 180px;
}
.stepComponent {
  width: 150px;
}
.btnStyle {
  width: 90px;
}
</style>
